import React from 'react';
import { Sparkles, CalendarCheck, PauseCircle } from 'lucide-react';
import { TRIAL_DAYS } from '../../lib/trial';
import './TrialTimeline.css';

// The free trial, spelled out as three moments. Shown on the signup review
// step and on the checkout page so "no card to start" is never a surprise.
export default function TrialTimeline({ price, compact = false }) {
  const steps = [
    { Icon: Sparkles, when: 'Today', title: 'Full access, no card', body: 'Your practice goes live the moment you confirm. Stripe skips the card field entirely.' },
    { Icon: CalendarCheck, when: `Day ${TRIAL_DAYS}`, title: 'Your free days end', body: `Keep going by adding a card any time before then${price ? ` — ${price} per location per month` : ''}.` },
    { Icon: PauseCircle, when: 'No card yet?', title: 'Nothing is charged', body: 'Your account simply pauses until you add one. Cancel anytime from billing settings.' },
  ];
  return (
    <ol className={`trial-tl ${compact ? 'is-compact' : ''}`}>
      {steps.map((s) => (
        <li key={s.when}>
          <span className="trial-tl-icon"><s.Icon size={14} strokeWidth={2.2} /></span>
          <span className="trial-tl-when">{s.when}</span>
          <span className="trial-tl-title">{s.title}</span>
          {!compact && <span className="trial-tl-body">{s.body}</span>}
        </li>
      ))}
    </ol>
  );
}
